import Replace from "./Replace/index.js";
class Index {
    rc;
    _parent;
    deviceId;
    constructor(_parent, deviceId = null) {
        this._parent = _parent;
        this.rc = _parent.rc;
        this.deviceId = deviceId;
    }
    path(withParameter = true) {
        if (withParameter && this.deviceId !== null) {
            return `${this._parent.path()}/devices/${this.deviceId}`;
        }
        return `${this._parent.path()}/devices`;
    }
    replace() {
        return new Replace(this);
    }
}
export default Index;
